module.exports = __webpack_public_path__ + "static/media/arcs.8e8bb520.svg";